export const SET_IS_HIDE = 'SET_IS_HIDE';

export const SET_HIDE_DATA = 'SET_HIDE_DATA';

export const SET_MARK_LIST = 'SET_MARK_LIST';

export const SET_ACTIVE_MARK_UUID = 'SET_ACTIVE_MARK_UUID';

export const SET_PAGINATION = 'SET_PAGINATION';

export const SET_ACTIVE_CONTEXT_MENU_TYPE = 'SET_ACTIVE_CONTEXT_MENU_TYPE';

export const SET_MARK_EDIT_STATE = 'SET_MARK_EDIT_STATE';

export const SET_MARK_USERS = 'SET_MARK_USERS';

export const SET_MARK_STATE = 'SET_MARK_STATE';

export const MARK_STATE = {
  // 允许所有
  ALLOW_ALL: 1 << 0,
  // 禁止标注
  ENABLED_CREATE: 1 << 1,
  // 禁止编辑
  ENABLED_EDIT: 1 << 2,
};
